export default "__VITE_ASSET__BJzTIlQa__"